export default __webpack_public_path__ + "img/master.d053fa3a.png";